export default {
  strict: true,
  namespaced: true,
  state: {
    show: false
  },
  mutations: {
    show (state) { state.show = true },
    hide (state) { state.show = false }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/notification-permission.js